import React from "react";
import {useMutation} from "react-query";
import {z} from "zod";
import {Formik, Form} from "formik";
import {toFormikValidationSchema} from "zod-formik-adapter";
import {messages} from "@reside/forms";

import {
  Button,
  PublicFormLayout,
  TextField,
  styled,
  Text,
  Icon,
  Paragraph,
} from "@reside/ui";
import {CreateResetPasswordDto} from "../../utils/types/user";

import {UserService} from "../../services/UserService";
import {SuccessMessage} from "./style";
import {StyledLink} from "../page-admin-login/style";

const Schema = z.object({
  email: z.string().email(messages.email),
});

const ButtonCenter = styled.div`
  width: fit-content;
  margin: 18px auto 0;
`;

const Center = styled.div`
  margin: 0 auto;
  text-align: center;
`;

export const PagePasswordReset = () => {
  const {mutate, isLoading, isSuccess, error} = useMutation(
    UserService.resetPassword,
  );

  return (
    <Formik<CreateResetPasswordDto>
      initialValues={{email: ""}}
      onSubmit={values => mutate(values)}
      validationSchema={toFormikValidationSchema(Schema)}
    >
      {({submitForm}) => (
        <PublicFormLayout title="Reset Password">
          {isSuccess || error ? (
            <Center>
              <SuccessMessage>
                <Icon name="check-circle" color="green100" size={32} />
                <Text as="p" color="green100" fontSize={4} fontWeight="medium">
                  Reset password link sent
                </Text>
              </SuccessMessage>

              <Paragraph fontSize={4}>
                If an account with this email address exists you will receive an
                email with a link to reset your password.
              </Paragraph>
              <br />
              <Paragraph fontSize={4}>
                If you are SSO registered please contact your administrator
              </Paragraph>
              <br />
              <StyledLink
                style={{fontSize: "16px", fontWeight: 600, marginTop: "32px"}}
                to="/admin"
              >
                Back to Log In
              </StyledLink>
            </Center>
          ) : (
            <Form>
              <TextField
                name="email"
                type="email"
                label="E-mail address"
                placeholder="Enter your E-mail Address"
              />

              <ButtonCenter>
                <Button
                  type="submit"
                  color="primary"
                  disabled={isLoading}
                  onClick={submitForm}
                >
                  {isLoading ? <>Sending a link...</> : <>Send a link</>}
                </Button>
              </ButtonCenter>
            </Form>
          )}
        </PublicFormLayout>
      )}
    </Formik>
  );
};
